import { ApiFile } from 'src/types';

const isFileObject = (file: ApiFile) => file.format === 'xml' || file.format === '1c';

export default isFileObject;

export const isNotFileObject = (file: ApiFile) => !isFileObject(file);